import { FC, useContext } from 'react'
import PageContainer from 'shared/components/PageContainer'
import PACKAGE from '../../package.json'
import LocalizationContext from 'shared/contexts/LocalizationContext'

type Props = {
  error: string
  locale: string
}

const ErrorPage: FC<Props> = ({ error, locale }) => {
  const { getString } = useContext(LocalizationContext)

  return (
    <PageContainer version={PACKAGE.version}>
      <div className='flex flex-col items-center justify-center h-full text-white bg-[#1F2937]'>
        <p>{getString('an_unexpected_error_occurred', locale)}</p>
        <p className='text-red-600 px-4 pt-2 text-center'>Error: {error}</p>
      </div>
    </PageContainer>
  )
}

export default ErrorPage
